import {defineStore} from "pinia"
import {Toast} from "vant"
import axios from "axios"

import {DataType, FieldItemType, StateType, UploadImageData, AnswerType, SelectAnswer} from "./dataType"
import {getUrlParam,formatSample} from "./utils"

const baseUrl = "//app-act.ngzb.com.cn/collect/index/"
const apiHost = "//app-act.ngzb.com.cn"

export const usePageStore = defineStore("pageStore", {
    state: (): StateType => ({
        activityId: getUrlParam("activityId"),
        userid: "",
        imei: "",
        bindPhone: "",
        pageInfo: {
            collect: undefined,
            fields: []
        },
        postData: new Map<string, string>(),
        submitLock: false,
        currPage: 0,
        answers: [],
        isSample: true,
        totolSel: 1,
        selectAnswers: new Map<string, SelectAnswer[]>(),
        rightNum: 0,
    }),
    actions: {
        // 提交选择项
        postSelectAnswer(key: string, value: SelectAnswer[], isRight: boolean) {
            if (isRight) {
                this.$state.rightNum++
            }
            this.$state.selectAnswers.set(key, value)
        },
        // 提交答案
        async submitResult() {
            if (this.$state?.pageInfo?.collect?.connection_num!==0 && this.$state.pageInfo.collect) {
                return this.$state.rightNum >= this.$state.pageInfo.collect.connection_num
            } else {
                return this.$state.rightNum >= this.$state.totolSel;
            }

        },
        // 切换页面
        changePage(index: 1|2|3) {
          this.$state.currPage = index
        },
        // 表单提交
        async submitData(data: Map<string,string>): Promise<boolean> {
            if (this.$state.submitLock) {
                Toast("请勿提交太频繁！")
                return false
            }
            this.$patch({
                submitLock: true
            })
            Toast.loading("正在提交信息")
            const formData = new FormData()
            let resInfo = false
            formData.append("id" ,this.$state.activityId)
            formData.append("imei", this.$state.imei)
            formData.append("userId", this.$state.userid)
            formData.append("data", JSON.stringify(Object.fromEntries(data)))
            await axios.post<{
                code: number,
                msg: string,
            }>(`${baseUrl}add`, formData, {
                headers: { 'content-type': 'application/x-www-form-urlencoded' }
            }).then((result) => {
                const { data, status } = result
                if (status === 200) {
                    const { msg, code }  =data
                    Toast(msg)
                    if (code === 10099) {
                        Toast("请先在用户中心绑定手机")
                    }
                    resInfo = true
                } else {
                    Toast("提交失败！code："+status)
                    resInfo = false
                }
            }).catch(error => {
                Toast("提交失败！content："+error)
            }).finally(() => {
                setTimeout(() => {
                    this.$patch({
                        submitLock: false
                    })
                }, 2000)

            })
            return resInfo
        },
        // 获取页面数据
        async queryPageInfo(): Promise<Error|undefined> {
            const id = this.$state.activityId
            const result = await axios.get<{
                code: number,
                msg: string,
                data: DataType,
            }>(`${baseUrl}getIndex`, {
                params: {id}
            }).then<[DataType|undefined, Error|undefined]>(result => {
                const { data:outData, status } = result
                if (status == 200) {
                    const { msg, data, code } = outData
                    if ([0,10001].includes(code)) {
                        return [data, undefined]
                    } else {
                        throw new Error(msg)
                    }
                } else {
                    throw new Error(`Code:${status}||请求失败`)
                }
            }).catch<[DataType|undefined, Error|undefined]>((error: Error) => {
                return [undefined, error]
            })

            const [ data, error ] = result

            if (data) {
                this.$patch({
                    pageInfo: data
                })
                // 转换答案
                this.$patch((state) => {
                    const { fields } = data
                    console.log('data', data)
                    let coverArr:AnswerType[] = []

                    fields?.forEach((item) => {
                        const rightIndex = item.answer.split(',').map(item => parseInt(item))
                        if (typeof item.item_value === 'string') {
                            item.item_value = item.item_value.split(",")
                        }
                        coverArr.push({
                            id: item.id,
                            title: item.name,
                            type: item.item_type,
                            news_url: item.news_url,
                            answers: item.item_value.map((inner_item,index) => {
                                return {
                                    isRight: rightIndex.includes(index),
                                    text: inner_item
                                }
                            })
                        })
                        console.log(coverArr)
                    })
                    // 数据随机转换
                    if (this.$state.isSample) {
                        coverArr = formatSample(coverArr)
                    }
                    state.answers.push(...coverArr)
                    console.log('coverArr',coverArr)
                    state.totolSel = coverArr.length
                })
            } else if (error) {
                return error
            }
        },
        async uploadImage(file: File|Blob, type:string) {
            Toast.loading("")
            const imei = this.$state.imei
            const userId = this.$state.userid
            const response = await axios
                .post<UploadImageData>(
                    `${apiHost}/vote/Vote/saveFile`,
                    {
                        dir: type,
                        userId,
                        imei,
                        file: file,
                    },
                    {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    }
                )
                .catch((err) => {
                    Toast(err);
                })
                .finally(() => {
                    Toast.clear()
                });
            if (response && response.status === 200) {
                const { code, msg } = response.data;
                if (code === 0) {
                    Toast({
                        message: "上传成功！",
                        duration: 2000,
                    });
                } else {
                    Toast(msg);
                }
            } else {
                Toast("网络错误！");
            }
            return response;
        },
    },
})
